import {tokens} from '@bsky.app/alf'

export * from '@bsky.app/alf/dist/tokens'

export const color = {
  temp_purple: tokens.labelerColor.purple,
  temp_purple_dark: tokens.labelerColor.purple_dark,
} as const

export const gradients = {
  // Batesky orange rebrand: primary/sky/midnight recolored from blue to orange
  primary: {
    values: [
      [0, '#FCA573'],
      [0.4, '#FA7A2D'],
      [0.6, '#FFB45A'],
      [1, '#FC9E5A'],
    ],
    hover_value: '#FA7A2D',
  },
  sky: {
    values: [
      [0, '#FA7A2D'],
      [1, '#FCA573'],
    ],
    hover_value: '#FA7A2D',
  },
  midnight: {
    values: [
      [0, '#6D2902'],
      [1, '#A04A1F'],
    ],
    hover_value: '#6D2902',
  },
  sunrise: {
    values: [
      [0, '#4E90AE'],
      [0.4, '#AEA3AB'],
      [0.8, '#E6A98F'],
      [1, '#F3A84C'],
    ],
    hover_value: '#AEA3AB',
  },
  sunset: {
    values: [
      [0, '#6772AF'],
      [0.6, '#B88BB6'],
      [1, '#FFA6AC'],
    ],
    hover_value: '#B88BB6',
  },
  summer: {
    values: [
      [0, '#FF6A56'],
      [0.3, '#FF9156'],
      [1, '#FFDD87'],
    ],
    hover_value: '#FF9156',
  },
  nordic: {
    values: [
      [0, '#083367'],
      [1, '#9EE8C1'],
    ],
    hover_value: '#3A7085',
  },
  bonfire: {
    values: [
      [0, '#203E4E'],
      [0.4, '#755B62'],
      [0.8, '#CD7765'],
      [1, '#EF956E'],
    ],
    hover_value: '#755B62',
  },
} as const
